var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.908 77.284 79.184 65 57.908 52.716v24.568Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.816
  })));
};
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDEzMCAxMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01Ny45MDc5IDc3LjI4MzlMNzkuMTg0MyA2NUw1Ny45MDc5IDUyLjcxNjFMNTcuOTA3OSA3Ny4yODM5WiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC44MTU3MjIiLz4KPC9zdmc+Cgo=";